import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import RequireAuth from "./components/RequireAuth";
import Layout from "./components/Layout";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Paywall from "./pages/Paywall";
import Dashboard from "./pages/Dashboard";
import Yunov from "./pages/Yunov";
import Drugs from "./pages/Drugs";
import Admin from "./pages/Admin";
import PaymentReturn from "./pages/PaymentReturn";
import Coverage from "./pages/Coverage";
import DocCenter from "./pages/DocCenter";
import ChangePassword from "./pages/ChangePassword";
import CoverageAction from "./pages/CoverageAction";
import ReferralSender from "./pages/ReferralSender";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

const Protected = ({ children, admin = false }) => (
  <RequireAuth requireAdmin={admin}>
    <Layout>{children}</Layout>
  </RequireAuth>
);

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/paywall" element={
              <RequireAuth requireAccess={false}><Paywall /></RequireAuth>
            } />
            <Route path="/payment/return" element={
              <RequireAuth requireAccess={false}><PaymentReturn /></RequireAuth>
            } />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/yunov" element={<Protected><Yunov /></Protected>} />
            {/* Buying.grp + Implant.id hidden until vendor contracts + identification model are ready */}
            <Route path="/buying" element={<Navigate to="/dashboard" replace />} />
            <Route path="/implant" element={<Navigate to="/dashboard" replace />} />
            <Route path="/drugs" element={<Protected><Drugs /></Protected>} />
            <Route path="/coverage" element={<Protected><Coverage /></Protected>} />
            <Route path="/doc-center" element={<Protected><DocCenter /></Protected>} />
            <Route path="/change-password" element={
              <RequireAuth requireAccess={false}><ChangePassword /></RequireAuth>
            } />
            {/* Magic-link from admin email — no login required, token authorizes the action */}
            <Route path="/coverage-action" element={<CoverageAction />} />
            <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
            {/* Referral Sender is served as a STANDALONE document (document.write
                replaces the React tree with the artifact's HTML), so it must NOT
                be wrapped in the GCOMS Layout chrome. Auth still gated as admin. */}
            <Route path="/referrals" element={
              <RequireAuth requireAdmin><ReferralSender /></RequireAuth>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
